import { closeDialog, openDialog } from '@/dialogs/actions';

export const CREATE_EXPORT_SWAPS_DIALOG = 'CREATE_EXPORT_SWAPS_DIALOG';

export const openExportSwapsDialog = openDialog.bind(null, CREATE_EXPORT_SWAPS_DIALOG);
export const closeExportSwapsDialog = closeDialog.bind(null, CREATE_EXPORT_SWAPS_DIALOG);
